
export default {
  name: 'pick-room',
  props: {
    value: { type: Boolean, default: false },
    landlordId: { default: null }
  },
  data: function () {
    return {
      keyword: '',
      selected: {},
      busy: false,
      loading: false,
      rooms: [],
      groups: []
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    selectedCount: function () {
      return Object.keys(this.selected).length;
    },
    keywordText: function () {
      return (this.keyword || '').trim().toLowerCase();
    },
    hitRooms: function () {
      var kw = this.keywordText;
      if (!kw) return [];
      var t = this;
      return this.rooms.filter(function (room) {
        return t.matches(room, kw);
      });
    },
    visibleGroups: function () {
      var t = this;
      return this.groups.filter(function (group) {
        return t.roomsOf(group).length > 0;
      });
    }
  },
  watch: {
    value: function (opened) {
      if (!opened) return;
      this.keyword = '';
      this.selected = {};
      this.busy = false;
      this.loadList();
    }
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else this.toast('失敗しました');
    },
    focusSearch: function () {
      if (this.$refs.search) this.$refs.search.focus();
    },
    close: function () {
      this.$emit('input', false);
    },
    hasLandlord: function (room) {
      var id = room && room.landlord_id;
      return id != null && id !== '' && Number(id) !== 0;
    },
    canPick: function (room) {
      return !this.hasLandlord(room);
    },
    matches: function (room, kw) {
      var name = ((room && room.name) || '') + ' ' + ((room && room.name_en) || '');
      return name.toLowerCase().indexOf(kw) > -1;
    },
    roomsOf: function (group) {
      var kw = this.keywordText;
      var t = this;
      return (group.rooms || []).filter(function (room) {
        return t.matches(room, kw);
      });
    },
    boxClass: function (room) {
      if (!this.canPick(room)) return 'is-off';
      if (this.selected[room.id]) return 'is-on';
      return '';
    },
    toggle: function (room) {
      if (!this.canPick(room) || this.busy) return;
      if (this.selected[room.id]) this.$delete(this.selected, room.id);
      else this.$set(this.selected, room.id, true);
    },
    loadList: function () {
      var t = this;
      t.loading = true;
      t.rooms = [];
      t.groups = [];
      axios.get('room').then(function (res) {
        if (!res.data || res.data.status != 1) {
          t.loading = false;
          t.toastFail(res.data && res.data.status);
          return;
        }
        var rooms = (res.data.options && res.data.options.items) || [];
        var dict = {};
        rooms.forEach(function (room) {
          dict[room.id] = room;
        });
        t.rooms = rooms;
        axios.get('group').then(function (res2) {
          t.loading = false;
          if (!res2.data || res2.data.status != 1) {
            t.toastFail(res2.data && res2.data.status);
            return;
          }
          var placed = {};
          var groups = ((res2.data.options && res2.data.options.items) || []).map(function (group, index) {
            var list = [];
            String(group.room_ids || '').split(',').forEach(function (raw) {
              var id = String(raw || '').trim();
              if (!id || !dict[id] || placed[id]) return;
              placed[id] = true;
              list.push(dict[id]);
            });
            return {
              key: group.id || ('g-' + index),
              name: group.name,
              expanded: true,
              rooms: list
            };
          }).filter(function (group) {
            return group.rooms.length > 0;
          });
          var loose = rooms.filter(function (room) {
            return !placed[room.id];
          });
          if (loose.length) {
            groups.push({
              key: 'ungrouped',
              name: '未分類',
              expanded: true,
              rooms: loose
            });
          }
          t.groups = groups;
        }).catch(function () {
          t.loading = false;
          t.toast('通信に失敗しました');
        });
      }).catch(function () {
        t.loading = false;
        t.toast('通信に失敗しました');
      });
    },
    onOk: function () {
      var ids = Object.keys(this.selected).map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return id > 0;
      });
      var landlordId = Number(this.landlordId);
      if (!ids.length) {
        this.toast('宿を選んでください');
        return;
      }
      if (!landlordId) {
        this.toast('オーナーが指定されていません');
        return;
      }
      if (this.busy) return;
      this.busy = true;
      this.assignNext(ids, 0, landlordId);
    },
    assignNext: function (ids, index, landlordId) {
      var t = this;
      if (index >= ids.length) {
        t.busy = false;
        t.toast('追加しました');
        t.close();
        t.$emit('assigned');
        return;
      }
      axios.post('room/assignLandlord', {
        room_id: ids[index],
        landlord_id: landlordId
      }).then(function (res) {
        if (!res.data || res.data.status != 1) {
          t.busy = false;
          t.toastFail(res.data && res.data.status);
          if (index > 0) t.$emit('assigned');
          t.loadList();
          t.selected = {};
          return;
        }
        t.assignNext(ids, index + 1, landlordId);
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
        if (index > 0) t.$emit('assigned');
      });
    },
    onCancel: function () {
      if (this.busy) return;
      this.close();
    }
  }
};
